import React, { useState, useEffect } from 'react';
import { Tooltip } from 'carbon-components-react';
import DashboardSummary from '../DashboardSummaryNew';
import callPostApi from 'requests/PostRequests';
import * as Constants from '../../../requests/URLConstants';
import DashboardLineChart from '../DashboardLineChart';
import DashboardGroupedBarChart from '../DashboardGroupedBarChart';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'
import TableToolbarDownload from "../../../common/TableToolbarDownload";
import { abandonedProcessTrend, topFailureCategories, TableHeaders, MockData } from './MockData';
import * as SalesForceConfig from './../SalesForceConfig.js'
import DashboardTable from '../DashboardTable';

require("./_abadonedprocess.scss");

const AbandonedProcesses = (props) => {

    const [abandonedProcessesLoading, setAbandonedProcessesTrendLoading] = useState(true);
    const [abandonedProcessesTrendGraphData, setAbandonedProcessesTrendGraphData] = useState([]);
    const [abandonedProcessesSummary, setAbandonedProcessesSummary] = useState([]);
    const [topFailuresData, setTopFailuresData] = useState([]);
    const [entityTrendData, setEntityTrendData] = useState([]);
    const [entityTableLoading, setEntityTableLoading] = useState(true);
    const [entityTableData, setEntityTableData] = useState([]);

    const lineGraphHeaders = [{ key: 'group', header: DashboardConstants.Group }, { key: 'date', header: DashboardConstants.Date },
    { key: 'value', header: DashboardConstants.Value }];

    useEffect(() => {
        getAbandonedProcessesTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getEntityTable(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
    }, [props.preferencesChanged])

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {

        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.salesforce_ops) {
            technology = dashboardFilterSelectionsSalesforce.technology;
            franchise = dashboardFilterSelectionsSalesforce.franchise;
            client = dashboardFilterSelectionsSalesforce.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    // "technologies": technology,
                    // "deployment_models": dashboardFilterSelectionsSalesforce.deployment_model,
                    // "business_competencies": dashboardFilterSelectionsSalesforce.competency,
                    // "incident_status": dashboardFilterSelectionsSalesforce.incident_status,
                    // "assignment_groups": dashboardFilterSelectionsSalesforce.assigned_group,
                    // "process_name": dashboardFilterSelectionsSalesforce.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace,
                "entity": SalesForceConfig.AbandonedProcess
            };
        } else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client = dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "assignment_groups": dashboardFilterSelectionsSAP.assigned_group,
                    "incident_status": dashboardFilterSelectionsSAP.incident_status,
                    "automata_priority": dashboardFilterSelectionsSAP.priority
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }

        return bodyJSON;
    };

    const getAbandonedProcessesSummary = (params) => {
        let summary = [
            {
                title: DashboardConstants.Total,
                value: params.total ? params.total : 0
            },
            {
                title: DashboardConstants.RecurringFailures,
                value: params.recurringFailures ? params.recurringFailures : 0
            },
            {
                title: DashboardConstants.LongRunningSessions,
                value: params.longRunningSessions ? params.longRunningSessions : 0
            }
        ];
        setAbandonedProcessesSummary(summary);
    };


    const prepareIntegrationTrendData = (response) => {
        let graphData = []; let barChartObj = {}; let barChartData = [];
        let sourcebarChartObj = {}; let sourceBarChartData = [];
        let summaryData = { total: 0, successful: 0, failures: 0, recurringFailures: 0, longRunningSessions: 0 };
        let graphObj = {};
        if (response.body) {
            let buckets = response.body.aggregations.events.buckets;
            for (var key of Object.keys(buckets)) {
                if (key === 'total') {
                    let statusBucket = buckets[key].trend.buckets;
                    for (let i = 0; i < statusBucket.length; i++) {
                        graphObj = {
                            "group": key,
                            "date": moment(statusBucket[i].key_as_string).format('YYYY-MM-DD'),
                            "value": statusBucket[i].count.value
                        }
                        graphData.push(graphObj)
                    }
                    summaryData.total = buckets.total.count.value ? buckets.total.count.value : 0;
                }
            }

            let errorBuckets = response.body.aggregations.top_errors.errors.buckets;
            for (let j = 0; j < errorBuckets.length; j++) {
                barChartObj = {
                    group: errorBuckets[j].key,
                    key: errorBuckets[j].key,
                    value: errorBuckets[j].count.value
                };
                barChartData.push(barChartObj);
            }

            let sourceErrorBuckets = response.body.aggregations.top_errorSources.errors.buckets;
            for (let j = 0; j < sourceErrorBuckets.length; j++) {
                sourcebarChartObj = {
                    group: sourceErrorBuckets[j].key,
                    key: sourceErrorBuckets[j].key,
                    value: sourceErrorBuckets[j].count.value
                };
                sourceBarChartData.push(sourcebarChartObj);
            }

            if (response.body.aggregations && response.body.aggregations.alerts) {
                let summaryBucket = response.body.aggregations.alerts.buckets;
                summaryData.recurringFailures = summaryBucket.recurring.count.value ? summaryBucket.recurring.count.value : 0;
                summaryData.longRunningSessions = summaryBucket.longRunning.count.value ? summaryBucket.longRunning.count.value : 0;
            }
        }
        graphData.sort((a, b) => { return new Date(a.date) - new Date(b.date) });
        return { graphData, summaryData, barChartData, sourceBarChartData };
    };

    const getAbandonedProcessesTrend = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETSALESFORCETRENDGRAPH, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareIntegrationTrendData(resp);
                    setAbandonedProcessesTrendGraphData(formattedData.graphData);
                    getAbandonedProcessesSummary(formattedData.summaryData);
                    setTopFailuresData(formattedData.barChartData);
                    setEntityTrendData(formattedData.sourceBarChartData);
                    setAbandonedProcessesTrendLoading(false);
                }).catch((error) => {
                    setAbandonedProcessesTrendLoading(false);
                });
        }
    }

    const prepareEntityTableData = (response) => {
        let tableData = [];
        let tableObj = {};
        if (response.body) {
            let buckets = response.body.aggregations.eventSource.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let statsBucket = buckets[i].type.buckets;
                for (let j = 0; j < statsBucket.length; j++) {
                    tableObj = {
                        id: Math.random() + i,
                        type: statsBucket[j].key,
                        entity: buckets[i].key,
                        failures: statsBucket[j].stats.buckets.failures.count.value,
                        successful: statsBucket[j].stats.buckets.successful.count.value,
                        total: statsBucket[j].stats.buckets.total.count.value
                    }
                    tableData.push(tableObj);
                }
            }
        }
        return { tableData };
    }

    const getEntityTable = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setEntityTableLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETSALESFORCETRENDTABLE, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareEntityTableData(resp);
                    setEntityTableData(formattedData.tableData);
                    setEntityTableLoading(false);
                }).catch((error) => {
                    setEntityTableLoading(false);
                });
        }
    }

    const lineChartColors = {
        'total': "#0f62fe",
        'failure': "#da1e28",
        'successful': "#198038",
        'Total': "#0f62fe",
        'Failure': "#da1e28",
        'Successful': "#198038"
    };

    return (
        <div className="top-margin dashboard abandoned-processes">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={abandonedProcessesLoading} summary={abandonedProcessesSummary} title={DashboardConstants.AbandonedProcesses} />
                </div>
                <div className="dashboard-charts-container">
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div style={{ display: "flex" }}>
                                <div>{DashboardConstants.AbandonedProcessesTrend}</div>
                                <Tooltip direction="right">
                                    <div style={{ color: "black", fontSize: "14px" }}>
                                        {DashboardConstants.LineChartTooltip}
                                    </div>
                                </Tooltip>
                            </div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={abandonedProcessesTrendGraphData} headers={lineGraphHeaders} title={DashboardConstants.AbandonedProcessesTrend} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="line-chart">
                            <DashboardLineChart
                                lineGraphData={abandonedProcessesTrendGraphData}
                                loading={abandonedProcessesLoading}
                                graphTitle={DashboardConstants.Count}
                                modalTitle=""
                                showTotal={false}
                                colors={lineChartColors}
                            />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={abandonedProcessesLoading}
                                    title={DashboardConstants.TopFailureReasons}
                                    groupedBarChartData={topFailuresData}
                                    //downloadableData={topFailuresDownloadableData}
                                    graphAxesTitle={DashboardConstants.Count}
                                    graphBottomTitle={DashboardConstants.Reasons}
                                // headers={SchedulingEfficiencyTables.LongRunningAutomataTableHeaders}
                                />
                            </div>
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={abandonedProcessesLoading}
                                    title={DashboardConstants.TopFailureSources}
                                    groupedBarChartData={entityTrendData}
                                    graphAxesTitle={DashboardConstants.Count}
                                    graphBottomTitle={DashboardConstants.Sources}
                                />
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.EventStatistics}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={entityTableData} headers={TableHeaders} title={DashboardConstants.EventStatistics} filename={DashboardConstants.EventStatistics} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="bold-border-table nested-table">
                            <DashboardTable loading={entityTableLoading} rows={entityTableData}
                                headers={TableHeaders} showPagination={true} isSortingAllowed={true}
                            />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default AbandonedProcesses;
